import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Dashboard from '../views/system/generator/Dashboard.vue'
import ProfileCompany from '../views/system/generator/ProfileCompany.vue'
import ProfileAdministrator from '../views/system/generator/ProfileAdministrator.vue'

import PageNotFound from '../views/error/404.vue'

Vue.use(VueRouter)

  const routes = [
    { path: "*",component: PageNotFound },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/system',
    name: 'System',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "system" */ '../views/system/System.vue'),
    children:[

      {
        path: '/system/generator/dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      //CONSUMIDORES
      {
        path: '/system/consumer/dashboard',
        name: 'DashboardConsumer',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/consumer/Dashboard.vue'),
      },
      {
        path: '/system/consumer/profile-company',
        name: 'ProfileCompany',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/consumer/ProfileCompany.vue'),
      },
      {
        path: '/system/consumer/withdrawal-points',
        name: 'WithdrawalPoints',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/consumer/WithdrawalPoints.vue'),
      },
      {
        path: '/system/consumer/energy-offers',
        name: 'MyOffers',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/consumer/MyOffers.vue'),
      },
      {
        path: '/system/consumer/request-tracking',
        name: 'RequestTracking',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/consumer/RequestTracking.vue'),
      },
      {
        path: '/system/consumer/closing',
        name: 'Closing',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/consumer/Closing.vue'),
      },
      {
        path: '/system/consumer/my-closing',
        name: 'MyClosing',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/consumer/MyClosing.vue'),
      },
      {
        path: '/system/consumer/my-contracts',
        name: 'MyContract',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/consumer/MyContract.vue'),
      },
      //GENERADORES
      {
        path: '/system/generator/profile-company',
        name: 'ProfileCompany',
        component: ProfileCompany
      },
      {
        path: '/system/generator/all-companies',
        name: 'AllCompanies',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/generator/AllCompanies.vue'),
      },
      {
        path: '/system/generator/my-offers',
        name: 'MyOffers',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/generator/MyOffers.vue'),
      },
      {
        path: '/system/generator/profile-administrator',
        name: 'ProfileAdministrator',
        component: ProfileAdministrator
      },
      {
        path: '/system/generator/detail-company',
        name: 'DailCompany',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/generator/DailCompany.vue'),
      },
      {
        path: '/system/generator/my-request',
        name: 'MyRequest',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/generator/MyRequest.vue'),
      },
      {
        path: '/system/generator/my-closing',
        name: 'MyClosing',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/generator/MyClosing.vue'),
      },
      {
        path: '/system/generator/my-contracts',
        name: 'MyContract',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/generator/MyContract.vue'),
      },
      //Reportes
      {
        path: '/system/reports/dashboard',
        name: 'SystemReports',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/reports/Reports.vue'),
        props: { backgroundMenu: '#7F03BB' },
      },
      {
        path: '/system/reports/my-reports',
        name: 'MyReports',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/reports/MyReports.vue'),
      },
      {
        path: '/system/reports/report-detail',
        name: 'ReportDetail',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/reports/ReportDetail.vue'),
      },
      {
        path: '/system/reports/create-report',
        name: 'CreateReport',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/reports/CreateReport.vue'),
      },
      {
        path: '/system/reports/payment',
        name: 'Payment',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/reports/Payment.vue'),
      },
      {
        path: '/system/reports/payment-2',
        name: 'Payment2',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/reports/Payment-2.vue'),
      },
      {
        path: '/system/reports/payment-success',
        name: 'PaymentSuccess',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/reports/PaymentSuccess.vue'),
      },
     
      {
        path: '/system/reports/collaborator-detail',
        name: 'CollaboratorDetail',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/reports/CollaboratorDetail.vue'),
      },
      //comun
      {
        path: '/system/contact',
        name: 'SystemContact',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/Contact.vue'),
      },
      {
        path: '/system/terms',
        name: 'Terms',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/Terms.vue'),
      },
      {
        path: '/system/about',
        name: 'About',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/About.vue'),
      },
      {
        path: '/system/card-master',
        name: 'About',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/CardMaestro.vue'),
      },
      {
        path: '/system/payment/my-plan',
        name: 'MyPlan',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/payment/MyPlan.vue'),
      },
      {
        path: '/system/payment/payment',
        name: 'Payment',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/payment/Payment.vue'),
      },
      {
        path: '/system/payment/payment-2',
        name: 'Payment',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/payment/Payment-2.vue'),
      },
      {
        path: '/system/payment/payment-success',
        name: 'PaymentSuccess',
        component: () => import(/* webpackChunkName: "system" */ '../views/system/payment/PaymentSuccess.vue'),
      },
    ]
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  build: {
    assetsPublicPath: '/'
  },
    routes
})

export default router
